/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Dropdown,
  Grid,
  Menu,
  Segment,
} from 'semantic-ui-react';
import DOCX_TEMPLATE_GUIDES, { DOCX_TEMPLATE_SUPPORTED_FONTS } from '../constants/docxTemplate';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class DocxTemplateGuides extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const tabs = DOCX_TEMPLATE_GUIDES;
    this.state = {
      isMobile,
      loading: true,
      mergeTags: [],
      filteredMergeTags: [],
      currentTab: tabs[0],
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  handleChangeTab = (e, { name }) => {
    const tabs = DOCX_TEMPLATE_GUIDES;
    const currentTab = tabs.find(tab => tab.value === name);
    this.setState({
      currentTab,
    });
  }
  renderTabContent = () => {
    const { t } = this.props;
    const { currentTab } = this.state;
    return (
      <div>
        {currentTab && currentTab.contents &&
          currentTab.contents.map((content, contentIndex) => (
            <div key={contentIndex} style={{ marginBottom: '32px' }}>
              <h3 style={{ marginBottom: '8px' }}>{t(content.title, { ns: TRANSLATION_FILES.translation })}</h3>

              {content.sections && content.sections.length > 0 && (
                <div style={{ marginTop: '10px' }}>
                  {content.sections.map((section, sectionIndex) => (
                    <div key={sectionIndex} style={{ marginBottom: '24px' }}>
                      {section.description && <p>{t(section.description, { ns: TRANSLATION_FILES.translation })}</p>}

                      {/* Handle Supported Fonts special case */}
                      {content.title === 'Supported Fonts' && (
                        <ul style={{ paddingLeft: '35px', marginTop: '8px' }}>
                          {DOCX_TEMPLATE_SUPPORTED_FONTS.map((font, idx) => (
                            <li key={idx} style={{ marginBottom: '4px' }}>{font}</li>
                          ))}
                        </ul>
                      )}

                      {section.examples && section.examples.length > 0 && (
                        <div style={{ marginLeft: '16px', marginTop: '8px' }}>
                          {section.examples.map((item, itemIndex) => (
                            <div key={itemIndex} style={{ marginBottom: '20px' }}>
                              <h4 style={{ marginBottom: '4px' }}>{t(item.title, { ns: TRANSLATION_FILES.translation })}</h4>

                              <div style={{ margin: '4px 0' }}>
                                <strong>{t('Input', { ns: TRANSLATION_FILES.translation })}:</strong>
                                <pre style={{ paddingLeft: '60px', whiteSpace: 'pre-line', margin: 0 }}>
                                  <code dangerouslySetInnerHTML={{ __html: item.syntax }} />
                                </pre>
                              </div>

                              {item.syntaxImage && (
                                <div style={{ marginTop: '8px' }}>
                                  <img src={`/assets/images/docxtemplates/${item.syntaxImage}`} alt="syntax" style={{ maxWidth: '100%', borderRadius: '8px' }} />
                                </div>
                              )}

                              <div style={{ margin: '4px 0' }}>
                                <strong>{t('Result', { ns: TRANSLATION_FILES.translation })}:</strong>
                                <pre style={{ paddingLeft: '60px', whiteSpace: 'pre-line', margin: 0 }}>
                                  <code dangerouslySetInnerHTML={{ __html: item.output }} />
                                </pre>
                              </div>

                              {item.outputImage && (
                                <div style={{ marginTop: '8px' }}>
                                  <img src={`/assets/images/docxtemplates/${item.outputImage}`} alt="output" style={{ maxWidth: '100%', borderRadius: '8px' }} />
                                </div>
                              )}

                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        }
      </div>
    );
  };

  render() {
    const { t } = this.props;
    const { currentTab, isMobile } = this.state;
    const tabs = DOCX_TEMPLATE_GUIDES;
    return (
      <Grid verticalAlign="middle" className="merge-tag-tab">
        <Grid.Row className="tab-menu">
          <Grid.Column width={16}>
            { isMobile ? (
              <div style={{ marginBottom: '10px' }}>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <Dropdown
                    fluid
                    selection
                    options={tabs.map(tab => ({
                      key: tab.value,
                      text: t(tab.text, { ns: TRANSLATION_FILES.translation }),
                      value: tab.value,
                    }))}
                    value={currentTab.value}
                    onChange={(e, { value }) => this.handleChangeTab(e, { name: value })}
                    style={{ flex: 1 }}
                  />
                </div>
              </div>
            ) : (
              <div style={{ overflowX: 'auto', overflowY: 'hidden', whiteSpace: 'nowrap' }}>
                <Menu attached="top" tabular style={{ minWidth: 'max-content', flexWrap: 'nowrap' }}>
                  {tabs.map((tab, key) => (
                    <Menu.Item
                      key={key}
                      name={tab.value}
                      onClick={this.handleChangeTab}
                      active={currentTab.value === tab.value}
                    >
                      {t(tab.text, { ns: TRANSLATION_FILES.translation })}
                    </Menu.Item>
                  ))}
                </Menu>
              </div>
            )}
            <Segment
              attached={isMobile ? false : 'bottom'}
              style={{
                height: '450px',
                overflowY: 'scroll',
                overflowX: 'hidden',
                borderTop: isMobile ? '1px solid #d4d4d5' : 'none',
              }}
            >
              {this.renderTabContent()}
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(DocxTemplateGuides);



// WEBPACK FOOTER //
// ./src/components/DocxTemplateGuides.jsx